import React from 'react';
import { Phone, MapPin, Clock, Star } from 'lucide-react';
import { businessInfo, openingHours } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-12 md:py-16 grid md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center">
                <span className="text-slate-900 font-bold text-xl">DC</span>
              </div>
              <div>
                <p className="font-bold text-white text-lg">DC Lock and Key</p>
                <p className="text-slate-400 text-sm">South Perth</p>
              </div>
            </div>
            <p className="text-slate-400 mb-4">
              Your trusted local locksmith serving South Perth and the greater Perth metro area with professional, reliable service.
            </p>
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <span className="text-slate-400 text-sm">{businessInfo.rating} ({businessInfo.reviewCount} reviews)</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-white text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-slate-400 hover:text-amber-400 transition-colors">
                  Our Services
                </a>
              </li>
              <li>
                <a href="#why-us" className="text-slate-400 hover:text-amber-400 transition-colors">
                  Why Choose Us
                </a>
              </li>
              <li>
                <a href="#reviews" className="text-slate-400 hover:text-amber-400 transition-colors">
                  Customer Reviews
                </a>
              </li>
              <li>
                <a href="#hours" className="text-slate-400 hover:text-amber-400 transition-colors">
                  Hours & Location
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-white text-lg mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href={businessInfo.phoneLink}
                  className="flex items-center gap-3 text-slate-400 hover:text-amber-400 transition-colors group"
                >
                  <div className="w-10 h-10 bg-slate-800 group-hover:bg-amber-500/10 rounded-lg flex items-center justify-center transition-colors">
                    <Phone className="w-5 h-5" />
                  </div>
                  <span className="font-medium">{businessInfo.phone}</span>
                </a>
              </li>
              <li>
                <div className="flex items-center gap-3 text-slate-400">
                  <div className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center">
                    <MapPin className="w-5 h-5" />
                  </div>
                  <span>{businessInfo.serviceArea}</span>
                </div>
              </li>
              <li>
                <div className="flex items-center gap-3 text-slate-400">
                  <div className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center">
                    <Clock className="w-5 h-5" />
                  </div>
                  <div className="text-sm">
                    <p>Mon–Fri: 7am – 6pm</p>
                    <p>Sat–Sun: 7am – 1pm</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm text-center md:text-left">
            © {currentYear} DC Lock and Key – South Perth. All rights reserved.
          </p>
          <a
            href={businessInfo.phoneLink}
            className="text-amber-400 hover:text-amber-300 font-medium transition-colors flex items-center gap-2"
          >
            <Phone className="w-4 h-4" />
            {businessInfo.phone}
          </a>
        </div>
      </div>

      {/* Spacer for sticky mobile bar */}
      <div className="h-16 md:hidden"></div>
    </footer>
  );
};

export default Footer;
